import _toArray from "../../toArray";
var exports = {};
var toArray = _toArray; // .files fallback, should be implemented in any browser

exports = function fallbackApi(dataTransfer) {
  var files = toArray(dataTransfer.files);
  return Promise.resolve(files);
};

export default exports;